import { Component, EventEmitter, OnInit, Output, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ICustomer } from '../../shared/models/customer.model';
import { StorageManagerService } from '../../shared/services/index';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { Utilities } from '../../shared/services/utilities';


@Component({
	selector: 'app-customer-selector',
	templateUrl: './customer-selector.component.html',
	styleUrls: ['./customer-selector.component.scss'],
	encapsulation: ViewEncapsulation.Emulated
})
export class CustomerSelectorComponent implements OnInit {

	selectedCustomer: string;
	header = 'Select';
	animationSettings: Object = { effect: 'None' };
	hide: any;
	fields: Object = { text: 'customerName', value: 'customerId' };
	customersWaterMark = 'Select one';
	ddwHeight = '220px';
	ddwWidth = '384px';

  userGuid: string;

	@Input() customers: ICustomer[];
  @Output() currentCustomer = new EventEmitter<string>();

    @ViewChild('csCustomersddw')
	csCustomersddw: DropDownListComponent;

    @ViewChild('dialog')
	dialog: DialogComponent;
	BtnClick: EmitType<object> = () => {
		this.dialog.show();
	}


  constructor(private storageManagerService: StorageManagerService, private utilService: Utilities) {}

  ngOnInit() {
    if (this.customers && this.customers.length > 0 && this.dialog) {
      this.dialog.hide();
    }
  }

	dlgBtnClick: EmitType<object> = () => {

		if (this.selectedCustomer) {
			this.processCustomer(+this.selectedCustomer);
			this.dialog.hide();
		}
	}

	dlgButtons: Object[] = [{
		click: this.dlgBtnClick.bind(this), buttonModel: { content: 'Get started', isPrimary: true, cssClass: 'e-disabled' }
	}];

	processCustomer(customerToFind: number) {

		let customer;

		if (this.customers && this.customers.length > 0) {

			customer = this.customers.find(c => c.customerId === customerToFind);

			if (customer) {

				this.currentCustomer.emit(customer);
			}
		}
	}

	customerChanged(event) {
		this.selectedCustomer = event.itemData.customerId;

		if (this.selectedCustomer) {
			const button = this.dialog.getButtons()[0];

			if (button) {
				button.cssClass = '';
			}
		}
	}
}

